export default __webpack_public_path__ + "static/media/maneje.c42ad26e.png";